import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BasysOperaComponent } from './basys-opera.component';
import { RouterModule } from '@angular/router';
import { BasysCoreAuthenticationModule } from '@barthauer/basys/core/authentication';
import { OperaModule } from '@barthauer/abc/maintenance/opera/core';

@NgModule({
  imports: [CommonModule, RouterModule, BasysCoreAuthenticationModule, OperaModule],
  declarations: [BasysOperaComponent],
  exports: [BasysOperaComponent, OperaModule],
})
export class BaSYSOperaCoreModule {
  constructor() {}
}
